<template>
<div>
<RegistrationHome/>

</div>
</template>

<script>
import RegistrationHome from "../../components/academic/RegistrationHome.vue";


export default {
  components: {
   RegistrationHome
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>